<template>
    <section>
        <div class="">
            <div class="">
                <div class="">
                    <div id="details" class="">
                        <div class="d-flex flex-column">
                        </div>
                        <gmap-map :center="center" :zoom="18" map-type-id="terrain" style="width: 100%; height: 75vh">

                            <gmap-marker :position="currentLocation" :icon="getMarkerIcon(currentLocation)"
                                @click="openInfoWindow">
                                <gmap-info-window :options="infoWindowOptions" :position="currentLocation"
                                    :opened="infoWindowOpen" @closeclick="closeInfoWindow">
                                    <div>
                                        Zone:<strong>{{ detailsOnZone.zoneName }} </strong><br />
                                        Driver Name:<strong>{{ detailsOnZone.driverFirstName + ' ' +
                                            detailsOnZone.driverLastName }}</strong> <br />
                                        Vehicle Number:<strong>{{ vehicleNumber }}</strong> <br />
                                        <!-- <strong>Name:</strong> {{ vehicleName }} -->
                                    </div>
                                </gmap-info-window>
                            </gmap-marker>


                            <!-- <gmap-marker :position="currentLocation" :icon="getMarkerIcon(currentLocation)" /> -->


                            <gmap-marker :position="startIcon" :icon="getStartMarkerIcon()" />
                            <gmap-marker :position="endIcon" :icon="getEndMarkerIcon()" />




                            <!-- <gmap-polyline :path="lineCoordinates" :options="lineOptions"
                                v-if="lineCoordinates.length > 0" /> -->


                            <gmap-polyline v-for="(polyline, index) in data" :key="index" :path="polyline.coordinates"
                                :options="getPolylineOptions(polyline.status)" />

                            <!-- <gmap-polyline v-for="(polyline, index) in data" :key="index"
                                :path="getLineCoordinates(polyline)" :options="getPolylineOptions(polyline.status)" /> -->


                        </gmap-map>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

    
    
<script>
import {
    eventBus
} from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import {
    MapElementFactory
} from "vue2-google-maps";

export default {
    name: "traccarMonitoringMap",
    data() {
        return {
            uri: "",
            imgSrc: "https://cdn2.iconfinder.com/data/icons/IconsLandVistaMapMarkersIconsDemo/256/MapMarker_Marker_Outside_Chartreuse.png",
            locationsPre: [],
            currentLocation: { lat: 0, lng: 0 },
            showByIndex: null,
            center: {
                lat: 0,
                lng: 0,
                //  lat: 28.6083167,
                // lng: 77.3718114,
            },
            data: [],
            startIcon: {},
            endIcon: {},
            /////////////////

            vehicleNumber: '',
            // vehicleName: 'Aditya',
            infoWindowOpen: false,
            infoWindowOptions: { pixelOffset: { width: 0, height: -35 } },
            detailsOnZone: {}

        };
    },


    mounted: function () {
        this.getCurrentLocation();
        eventBus.$off("traccarMonitoringMapInfoShow")
        eventBus.$on("traccarMonitoringMapInfoShow", (info) => {
            this.detailsOnZone = info;
            this.vehicleNumber = info.vehicleId.vNumber;


        });

        eventBus.$off("traccarMonitoringrouteFileGeoLoc");
        eventBus.$on("traccarMonitoringrouteFileGeoLoc", (receivedData) => {
            this.data = [];
            for (var i = 0; i < receivedData.length - 1; i++) {
                this.data.push({
                    coordinates: [{ lat: receivedData[i].coordinate[1], lng: receivedData[i].coordinate[0] },
                    { lat: receivedData[i + 1].coordinate[1], lng: receivedData[i + 1].coordinate[0] }],
                    status: receivedData[i].status
                })
            }
            this.center = {
                lat: this.data[0].coordinates[0].lat,
                lng: this.data[0].coordinates[0].lng
            }
            this.startIcon = {
                lat: this.data[0].coordinates[0].lat,
                lng: this.data[0].coordinates[0].lng
            }
            this.endIcon = {
                lat: this.data[this.data.length - 1].coordinates[0].lat,
                lng: this.data[this.data.length - 1].coordinates[0].lng

            }
            this.currentLocation = {
                lat: this.data[0].coordinates[0].lat,
                lng: this.data[0].coordinates[0].lng
            };

        });
        eventBus.$off("traccarMonitoringGMapSocket")
        eventBus.$on("traccarMonitoringGMapSocket", (location) => {
            this.updateLocation(location);
        });
    },

    methods: {
        getPolylineOptions(status) {
            return {
                strokeWeight: 7,
                geodesic: true,
                strokeColor: this.detailsOnZone.tripStatus === "Ongoing" ? status ? "#00FF00" : "#1976D2" : status ? "#00FF00" : "#FF0000",
                // strokeColor: status ? "#00FF00" : "#FF0000",
                strokeOpacity: 1.0,
            };
        },




        getStartMarkerIcon() {
            if (typeof google !== 'undefined') {
                return {
                    url: "/static/img/icon_start.png",
                    scaledSize: new google.maps.Size(60, 60),
                };
            }
            return ""
        },

        getEndMarkerIcon() {
            if (typeof google !== 'undefined') {
                return {
                    url: "/static/img/icon_finish.png",
                    scaledSize: new google.maps.Size(60, 60),
                };
            }
            return "";
        },

        openInfoWindow() {
            this.infoWindowOpen = true;
        },
        closeInfoWindow() {
            this.infoWindowOpen = false;
        },

        getCurrentLocation() {

            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const latitude = position.coords.latitude;
                        const longitude = position.coords.longitude;
                        this.center = {
                            lat: latitude,
                            lng: longitude,
                        };
                        this.currentLocation = {
                            lat: latitude,
                            lng: longitude,
                        };
                    },
                    (error) => {

                        console.error("Error getting user location:", error);
                    }
                );
            } else {
                console.error("Geolocation is not supported by this browser.");
            }
        },

        updateLocation(location) {
            // Update the center of the map to the new location
            this.center = {
                lat: location.lat,
                lng: location.lng,
            };

            // Update the current location marker
            this.currentLocation = {
                lat: location.lat,
                lng: location.lng,
            };

        },

        getMarkerIcon(staff) {
            const staffType = {
                surveyor: "/static/img/icone_trucks.png",
            }
            let url;
            url = staffType.surveyor
            return url
        },

        updatedTime(date) {
            return dateFormatter(date)
        },

        showLocByIndex(index) {
            this.showByIndex = index
        },

    },

    computed: {
    },

};
</script>
<style scoped>
.houses {
    font-size: 15px;
    font-weight: 550;
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// traccarMonitoringGMap.vue?3c5e36cc